module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'open': _vm.openSuggestion
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selection),
      expression: "selection"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.selection)
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enter.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.down.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.up.apply(null, arguments)
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.selection = $event.target.value
      }, _vm.change]
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.matches), function(suggestion, index) {
    return _c('li', {
      class: {
        'active': _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.suggestionClick(index)
        }
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(suggestion.name))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d8e8555!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/AutocompleteVehicle.vue
// module id = 453
// module chunks = 1